<button class="btn custom-btn" (click)="navigateToStartPage()">
  {{ 'global.back-to-start' | translate | uppercase }}
</button>
